import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';

class Filter extends Component {
  constructor(props) {
    super(props);
    //console.log("filter props", props)
    this.state = {
      list:this.props.list,
      label:this.props.label,
      placeholder:this.props.placeholder
    }
  }

  changeFilter = (event, value) => {
    const {label}=this.state
    this.props.InfoAutoComplete(label,value)
  };
  render(){
    const {list, label, placeholder } =this.state
    //console.log(list[0])
    const { classes } = this.props;
      
      return (
        <Autocomplete
          //id={option => option.id}
          defaultValue= {list[0]}
          options={list}
          getOptionLabel={option => option.nombre}
          onChange={this.changeFilter}
          closeIcon=""
          renderOption={params => {
            return (
                <div>{params.nombre}</div>
            );
          }}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={label}
              placeholder={placeholder}
              fullWidth
            />
          )}
        />
          
      );
    
  }
  
}


export default compose(withRouter, withStyles(styles))(Filter);